import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from '@mui/material';

export interface DeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    deleteType: 'category' | 'checklist' | null;
    deleteIndex: number | null;
    deleteChecklistTemplateUid: string | null;
    categorysData: { id: number; label: string }[];
    checklists: { id: number; label: string; templateUid?: string | null }[];
    setDeleteType: (type: 'category' | 'checklist' | null) => void;
    setDeleteIndex: (index: number | null) => void;
    setDeleteChecklistTemplateUid: (templateUid: string | null) => void;
    handleConfirmDelete: () => void;
  };
  

  export const DeleteDialog: React.FC<DeleteDialogProps> = ({
    open,
    onOpenChange,
    deleteType,
    deleteIndex,
    deleteChecklistTemplateUid,
    categorysData,
    checklists,
    setDeleteType,
    setDeleteIndex,
    setDeleteChecklistTemplateUid,
    handleConfirmDelete,
  }) => {
    return (
        <Dialog
            open={open}
            onClose={() => onOpenChange(false)}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
            maxWidth="sm"
            fullWidth
            style={{ zIndex: 9999 }}
            PaperProps={{
                style: {
                    backgroundColor: 'white',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    minWidth: '400px'
                }
            }}
        >
            <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-description">
                    Are you sure you want to delete the {deleteType === 'category' ? 'category' : 'checklist template'}{' '}
                    {deleteType === 'category' && deleteIndex !== null && (
                        <strong>&ldquo;{categorysData[deleteIndex]?.label}&rdquo;</strong>
                    )}
                    {deleteType === 'checklist' && deleteChecklistTemplateUid !== null && (
                        <strong>&ldquo;{checklists.find(c => c.templateUid === deleteChecklistTemplateUid)?.label}&rdquo;</strong>
                    )}? This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        onOpenChange(false);
                        setDeleteType(null);
                        setDeleteIndex(null);
                        setDeleteChecklistTemplateUid(null);
                    }}
                    style={{ color: 'black' }}
                >
                    Cancel
                </Button>
                <Button
                    style={{ backgroundColor: 'red', color: 'white' }}
                    onClick={handleConfirmDelete}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}
